export default __webpack_public_path__ + "static/media/123_catastroph_kawai_0001.86603719.png";